import { styled as t, Snackbar as f, Button as h, Box as c, Typography as l } from "@mui/material";
import x from "../../temp-lib/assets/icons/icon-ronin.svg.js";
import b from "../../temp-lib/components/share/generic/CloseButton.js";
import w from "../../temp-lib/components/share/next/Image.js";
import C from "../../ui-lib/components/MuiLoading.js";
import { MobileWalletSnackBarMode as o } from "../constants/index.js";
import { useTranslation as M } from "react-i18next";
import { jsxs as r, Fragment as S, jsx as n } from "react/jsx-runtime";
const k = t(f)`
  .MuiSnackbarContent-root {
    display: flex;
    flex-wrap: nowrap;
  }

  .MuiSnackbarContent-action {
    margin-right: 0px;
  }
`, B = t(w)`
  filter: grayscale(100%) brightness(3);
  width: 24px;
  height: 24px;
`, y = t(h)`
  background-color: #1473e9;
  color: white;
  margin-right: 8px;

  :hover,
  :active,
  :focus,
  :visited {
    background-color: #005bd7;
  }
`, v = t(c)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`, z = t(l)`
  font-size: 16px;
  font-weight: 700;
`, O = t(l)`
  font-size: 12px;
`, W = t(b)`
  width: 16px;
`, H = (g) => {
  const {
    open: p,
    onClose: i,
    onOpenApp: d,
    mode: a,
    loading: s
  } = g, {
    t: e
  } = M(), m = /* @__PURE__ */ r(S, {
    children: [/* @__PURE__ */ n(y, {
      onClick: d,
      disabled: s,
      children: s ? /* @__PURE__ */ n(C, {
        loading: !0,
        size: 24
      }) : a === o.Connect ? e("common.button.connect") : e("common.button.sign")
    }), /* @__PURE__ */ n(W, {
      onClick: i
    })]
  }), u = (() => {
    switch (a) {
      case o.Connect:
        return e("wallet.connect_wallet");
      case o.SignMessage:
        return e("wallet.sign_message");
      case o.SignTransaction:
        return e("wallet.sign_transaction");
      default:
        return;
    }
  })();
  return /* @__PURE__ */ n(k, {
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    open: p,
    disableWindowBlurListener: !0,
    onClose: i,
    message: /* @__PURE__ */ r(v, {
      children: [/* @__PURE__ */ n(B, {
        src: x.src
      }), /* @__PURE__ */ r(c, {
        children: [/* @__PURE__ */ n(z, {
          children: e("login.general.button.ronin")
        }), /* @__PURE__ */ n(O, {
          children: u
        })]
      })]
    }),
    action: m
  });
};
export {
  H as default
};
//# sourceMappingURL=OpenRoninWalletAppSnackBar.js.map
